import { ShareToolFormContainer, ShareToolTabLeftSection, ShareToolTabRightSection } from './ShareToolLayout';
import { ShareToolTabFooter } from './ShareToolTabFooter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackInteraction } from '../../usage-tracker/track';
import { ToolPreview } from './ToolPreview';
import { ShareToolCloseButton } from './ShareToolCloseButton';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/components/View';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const EmbedCodeShareTab = ({
  description,
  embedCode,
  note,
  previewComponent,
  previewScale
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShareToolTabLeftSection, {
      children: /*#__PURE__*/_jsxs(ShareToolFormContainer, {
        children: [/*#__PURE__*/_jsx("p", {
          children: description || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.embedCodeTab.description"
          })
        }), /*#__PURE__*/_jsx(CopyTextArea, {
          use: "code",
          value: embedCode,
          textAreaProps: {
            resize: false
          },
          buttonRowRenderer: props => {
            return /*#__PURE__*/_jsxs(View, {
              marginBlockStart: "400",
              as: "div",
              children: [note && /*#__PURE__*/_jsx(View, {
                marginBlockEnd: "400",
                as: "div",
                children: /*#__PURE__*/_jsx(Small, {
                  children: note
                })
              }), /*#__PURE__*/_jsx(Flex, {
                inlineSize: "100%",
                flexDirection: "column",
                children: /*#__PURE__*/_jsx(CopyButton, {
                  use: "tertiary",
                  value: props.value,
                  marginInline: "0",
                  responsive: true,
                  tooltipPlacement: "top",
                  onClick: props.onClick,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "CommerceToolsUiLib.shareToolModal.embedCodeTab.copyButton"
                  })
                })
              })]
            });
          },
          onCopy: () => {
            trackInteraction({
              action: 'copy embed code'
            });
          }
        })]
      })
    }), /*#__PURE__*/_jsx(ShareToolTabRightSection, {
      children: /*#__PURE__*/_jsx(ToolPreview, {
        scale: previewScale,
        children: previewComponent
      })
    }), /*#__PURE__*/_jsx(ShareToolTabFooter, {
      children: /*#__PURE__*/_jsx(ShareToolCloseButton, {})
    })]
  });
};